import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-bkash-white border-b-2 border-bkash-red shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-bkash-red border-2 border-bkash-red rounded"></div>
            <h1 className="text-2xl font-bold text-bkash-red">
              TEKNURA.COM
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#home" className="text-bkash-dark hover:text-bkash-red border-b border-transparent hover:border-bkash-red transition-colors">
              HOME
            </a>
            <a href="#services" className="text-bkash-dark hover:text-bkash-red border-b border-transparent hover:border-bkash-red transition-colors">
              SERVICES
            </a>
            <a href="#about" className="text-bkash-dark hover:text-bkash-red border-b border-transparent hover:border-bkash-red transition-colors">
              ABOUT
            </a>
            <a href="#contact" className="text-bkash-dark hover:text-bkash-red border-b border-transparent hover:border-bkash-red transition-colors">
              CONTACT
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-bkash-red border border-bkash-red px-3 py-1 hover:bg-bkash-red hover:text-bkash-white transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? 'CLOSE' : 'MENU'}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-bkash-red pt-4">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-bkash-dark hover:text-bkash-red border-l-2 border-transparent hover:border-bkash-red pl-4 transition-colors">
                HOME
              </a>
              <a href="#services" className="text-bkash-dark hover:text-bkash-red border-l-2 border-transparent hover:border-bkash-red pl-4 transition-colors">
                SERVICES
              </a>
              <a href="#about" className="text-bkash-dark hover:text-bkash-red border-l-2 border-transparent hover:border-bkash-red pl-4 transition-colors">
                ABOUT
              </a>
              <a href="#contact" className="text-bkash-dark hover:text-bkash-red border-l-2 border-transparent hover:border-bkash-red pl-4 transition-colors">
                CONTACT
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
